function listen() {
    const button = document.querySelector('[data-listen]');
    const content = document.querySelector('[data-listen-content]');
    if (!button || !content || !('speechSynthesis' in window)) return;

    const synth = window.speechSynthesis;
    const label = button.querySelector('[data-listen-label]');
    let state = 'idle';

    const setState = function (next) {
        state = next;
        button.classList.toggle('is-playing', state === 'playing');
        button.setAttribute('aria-pressed', state === 'playing' ? 'true' : 'false');
        if (label) {
            label.textContent = {
                idle: label.dataset.labelPlay,
                playing: label.dataset.labelPause,
                paused: label.dataset.labelResume
            }[state];
        }
    };

    const getText = function () {
        const title = document.querySelector('.gh-article-title');
        const clone = content.cloneNode(true);
        clone.querySelectorAll('script, style, figure, iframe, .kg-signup-card, .kg-cta-card').forEach((el) => el.remove());
        return [title ? title.textContent : '', clone.innerText].join('. ').replace(/\s+/g, ' ').trim();
    };

    // Speak in chunks: some browsers stop long utterances after ~15 seconds
    const speak = function () {
        const chunks = getText().match(/[^.!?]+[.!?]*\s*/g) || [];
        const lang = document.documentElement.lang || 'en';

        synth.cancel();
        chunks.forEach((chunk, i) => {
            const utterance = new SpeechSynthesisUtterance(chunk);
            utterance.lang = lang;
            if (i === chunks.length - 1) {
                utterance.onend = () => setState('idle');
            }
            synth.speak(utterance);
        });
        setState('playing');
    };

    button.hidden = false;
    setState('idle');

    button.addEventListener('click', function () {
        if (state === 'idle') {
            speak();
        } else if (state === 'playing') {
            synth.pause();
            setState('paused');
        } else {
            synth.resume();
            setState('playing');
        }
    });

    window.addEventListener('pagehide', () => synth.cancel());
}
